export const VISUALIZER_MANAGEMENT_ACTIONS = {
  getState: "getState",
  checkState: "checkState",
  setState: "setState",
  visualizerIsLoaded: "visualizerIsLoaded",
  closeVisualizerNavigation: "closeVisualizerNavigation",
  visualizerIsSaved: "visualizerIsSaved",
}

export const DASHBOARD_MESSAGING_ACTIONS = {
  updateCartItems: "updateCartItems", // parent -> visualizer
  setCostPrices: "setCostPrices", // parent -> visualizer
  jobDataAfterUpdate: "jobDataAfterUpdate", // visualizer -> parent
  setReferralData: "setReferralData", // parent -> visualizer
}
